import React, { Component } from "react"
import "./Rules.scss"
import ScrollableAnchor from "react-scrollable-anchor";
import _RulesData from "../../api/RulesBook.json"
import RuleItem from "./RuleItem";
import Slider from "../Helpers/Slider/Slider";
import { _getVotes } from "../Services/Fetch/votes";

class Rules extends Component {
    constructor() {
        super();
        this.nextSlide = this.nextSlide.bind(this);
        this.state = {
            currentSlide: 0,
            votesData: []
        }
    }
    async componentDidMount() {
        const data = await _getVotes.All();
        this.setState({
            votesData: data
        })
    }
    nextSlide() {
        if (this.state.currentSlide + 1 >= _RulesData.length) return;

        this.setState({
            currentSlide: this.state.currentSlide + 1
        })
    }
    getRules() {
        return _RulesData.map((item, index) => <RuleItem key={index} index={index} votesData={this.state.votesData} ID={index + 1} name={item.name} nextSlide={this.nextSlide} />)
    }
    postRulesOnSlider() {
        if (this.state.votesData.length == 0) return;
        return <Slider
            sectionName="Rule_book_Navigation"
            items={this.getRules()}
            currentSlide={this.state.currentSlide}
            loop={false}
            responsive={{
                0: {
                    items: 1,
                    slideBy: 1,
                    autoWidth: false,
                    rtl: true,
                    nav: true
                },
                1024: {
                    items: 1,
                    slideBy: 1,
                    center: false,
                    autoWidth: false,
                    rtl: true,
                    nav: true
                }
            }} />
    }
    render() {
        return (
            <ScrollableAnchor id="rules">
                <section className="section section-rules">
                    <div className="padding">
                        <div className="container">
                            <div className="slider">
                                {this.postRulesOnSlider()}
                            </div>
                        </div>
                    </div>
                </section>
            </ScrollableAnchor>
        )
    }
}

export default Rules;


// WEBPACK FOOTER //
// ./src/Components/Rules/Rules.jsx